module.exports = __webpack_public_path__ + "partnerBannerRightSide_mobile.png";